import { Entity, Field } from "typegraph";

@Entity({ one: "institution", many: "institutionsUser" })
export default class Institution {
	@Field()
	public id: number;

	@Field()
	public guid: string;

	@Field()
	public name: string;
}



// WEBPACK FOOTER //
// ./src/panels/catalog/cart/entities/Institutions.ts